module.exports = __webpack_public_path__ + "static/media/account_setting_black.b5cf2ba7.svg";